export default "__VITE_ASSET__BrD3MdME__"